/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */

import PaletteIconArrowRight from '@telus-uds/palette-allium/build/rn/icons/ArrowRight'
import PaletteIconArrowLeft from '@telus-uds/palette-allium/build/rn/icons/ArrowLeft'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    nextIcon: PaletteIconArrowRight,
    previousIcon: PaletteIconArrowLeft
  }
}
export default theme
